import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var arrow_down_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m16.5 13.5-3.7 3.7V4h-1.5v13.2l-3.8-3.7-1 1 5.5 5.6 5.5-5.6z" }) });
export {
  arrow_down_default as default
};
//# sourceMappingURL=arrow-down.js.map
